import React, { FC } from 'react';
import { StatusChipType, StatusChip } from './StatusChip';
import { useIntlBds } from '../../translations/BdsIntlProvider';
import { BpDesignSystem } from '../../types';

export type ActiveInactiveStatusChipProps = BpDesignSystem.Props<{
  active?: boolean;
}>;

export const ActiveInactiveStatusChip: FC<ActiveInactiveStatusChipProps> = ({ active, ...props }) => {
  const { intl } = useIntlBds();
  return (
    <StatusChip
      label={active ? intl.Chip.ActiveInactiveStatusChip.activeLabel : intl.Chip.ActiveInactiveStatusChip.inactiveLabel}
      type={active ? StatusChipType.LIGHT_BLUE : StatusChipType.GREY}
      {...props}
    />
  );
};
